export default "__VITE_ASSET__RGei5JJ4zpyRRcYRqD5PPw__"